import { getSettings, updateSettings } from "../../api/setting";
import { log2 } from "../../utils/log2";
import _ from "lodash";
import moment from "moment";
import CONFIG from "../../config/config";

const defaultPreferredThemeColor = "servquick";
const defaultPreferredAnimation = "No Animation";
const defaultContentOfBubbleMessage = "Do you need help?";
const defaultInputPixels = {
    xAxis: 0,
    yAxis: 0,
};
const log = log2("settings.vuex");
const setting = {
    namespaced: true,
    state: {
        allThemeColors: [
            "black",
            "gray",
            "yellow",
            "orange",
            "red",
            "green",
            "pink",
            "purple",
            "blue",
            "mango",
            "servquick",
            "custom",
        ],
        allAnimations: [
            "No Animation",
            "bounce",
            "flash",
            "pulse",
            "rubberBand",
            "shake",
            "bounceIn",
            "flip",
            "swing",
            "tada",
            "wobble",
            "jello",
        ],
        inputPixels: defaultInputPixels,
        contentOfBubbleMessage: defaultContentOfBubbleMessage,
        settings: {
            language: {},
            chatCustomizationSettings: {
                preferredThemeColor: defaultPreferredThemeColor,
                preferredAnimation: defaultPreferredAnimation,
            },
            customLoginFormEnabled: false,
            initialized: true,
            isEnabledTriggers: false,
        },
        initialized: false,
        offlineMode: false,
    },
    getters: {
        whatsappEnabled: (state) =>
            _.get(state.settings, "whatsapp.enabled", false) || _.get(state.settings, "whatsapp.plus.enabled", false),
        instagramEnabled: (state) => !!_.get(state.settings, "instagram.plan", false),
        telegramBotEnabled: (state) => !!_.get(state.settings, "telegrambot.token", false),
        telegramEnabled: (state) => !!_.get(state.settings, "telegrambot.token", false),
        gpt3Enabled: (state) =>
            (_.get(state.settings, "gpt3.trial", false) && _.get(state.settings, "gpt3.trialMessageLimit", 0) > 0) ||
            !!_.get(state.settings, "gpt3.apiKey", false),
        trialMessageLimit: (state) => _.get(state.settings, "gpt3.trialMessageLimit", 0),
        shouldSelectPlan(state, payload, rootState) {
            const createdAt = _.get(rootState, "site.site.createdAt");
            const basePrice = _.get(rootState, "site.site.basePrice.value", 150);
            const discount = _.get(rootState, "site.site.basePrice.discount", 0);
            const tookDays = Math.max(moment().diff(moment(createdAt, "YYYY-MM-DD"), "day"), 0);
            const isTrial = tookDays < _.get(state.settings, "plan.trialDays", 7);
            const findTrialPlan =
                rootState.site.plansAvailable && rootState.site.plans.find((plan) => plan.isTrialPlan);
            return !CONFIG.IS_DEVELOPMENT && !(isTrial || !findTrialPlan || basePrice === 0 || discount === 1);
        },
    },
    mutations: {
        SET_SETTINGS: (state, payload) => {
            log.debug("SET_SETTINGS", payload);
            state.settings = payload;
        },
        SET_SETTINGS_INITIALIZED: (state) => {
            state.initialized = true;
        },
        SET_SETTING_VALUE: (state, payload) => {
            log.debug("SET_SETTING_VALUE", payload);
            _.set(state.settings, payload.setting, payload.value);

            return state.settings;
        },
        OFFLINE_MODE_UPDATED: (state, payload) => {
            //log.debug("OFFLINE_MODE_UPDATED", payload)
            state.offlineMode = payload;
        },
    },
    actions: {
        getSettings({ commit }, data) {
            log("thisss", { data });
            return getSettings().then((response) => {
                let settings = {
                    language: {},
                };
                if (response.data.length > 0) {
                    settings = response.data[0];
                }
                if (settings.language == null) {
                    settings.language = {};
                }
                commit("SET_SETTINGS", settings);
                commit("SET_SETTINGS_INITIALIZED");
                return response;
            });
        },
        updateSettings({ state }, newSettings) {
            log("updateSettings called", { newSettings });
            return updateSettings(newSettings);
        },

        setSettingValue({ commit, state }, payload) {
            payload = Array.isArray(payload) ? payload : [payload];
            payload.forEach((x) => {
                commit("SET_SETTING_VALUE", x);
            });
            return Promise.resolve(state.settings);
        },
        setSettings({ commit }, payload) {
            commit("SET_SETTINGS", payload.settings);
        },
        offlineModeUpdated({ commit }, payload) {
            commit("OFFLINE_MODE_UPDATED", payload.offlineMode);
        },
    },
};

export default setting;
